"use strict";

var Cookie = {
  onload: document.addEventListener('DOMContentLoaded', function () {
    Cookie.init();
  }),
  init: function init() {
    // this.getUserTimeZone();
  },
  getCookie: function getCookie(cookieName) {
    var name = cookieName + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var value = decodedCookie.split(';');
    for (var i = 0; i < value.length; i++) {
      var item = value[i];
      while (item.charAt(0) === ' ') {
        item = item.substring(1);
      }
      if (item.indexOf(name) === 0) {
        return item.substring(name.length, item.length);
      }
    }
    return "";
  },
  setCookie: function setCookie(name, value, exdays) {
    var date = new Date();
    date.setTime(date.getTime() + exdays * 24 * 60 * 60 * 1000);
    var expires = "expires=" + date.toUTCString();
    document.cookie = name + "=" + value + ";" + expires + ";path=/";
  },
  getUserTimeZoneOffset: function getUserTimeZoneOffset() {
    var $cookie = Cookie.getCookie('timezone_offset');
    if ($cookie !== '' && $cookie !== undefined) {
      return $cookie;
    } else {
      var timezone_offset_minutes = new Date().getTimezoneOffset();
      timezone_offset_minutes = !timezone_offset_minutes ? 0 : -timezone_offset_minutes;
      Cookie.setCookie('timezone_offset', timezone_offset_minutes, 1);
      return timezone_offset_minutes;
    }
  },
  getUserTimeZone: function getUserTimeZone() {
    var date = new Date();
    var usertime = date.toLocaleString();
    var tzsregex = /\b(ACDT|ACST|ACT|ADT|AEDT|AEST|AFT|AKDT|AKST|AMST|AMT|ART|AST|AWDT|AWST|AZOST|AZT|BDT|BIOT|BIT|BOT|BRT|BST|BTT|CAT|CCT|CDT|CEDT|CEST|CET|CHADT|CHAST|CIST|CKT|CLST|CLT|COST|COT|CST|CT|CVT|CXT|CHST|DFT|EAST|EAT|ECT|EDT|EEDT|EEST|EET|EST|FJT|FKST|FKT|GALT|GET|GFT|GILT|GIT|GMT|GST|GYT|HADT|HAEC|HAST|HKT|HMT|HST|ICT|IDT|IRKT|IRST|IST|JST|KRAT|KST|LHST|LINT|MART|MAGT|MDT|MET|MEST|MIT|MSD|MSK|MST|MUT|MYT|NDT|NFT|NPT|NST|NT|NZDT|NZST|OMST|PDT|PETT|PHOT|PKT|PST|RET|SAMT|SAST|SBT|SCT|SGT|SLT|SST|TAHT|THA|UYST|UYT|VET|VLAT|WAT|WEDT|WEST|WET|WST|YAKT|YEKT)\b/gi;
    var timezonenames = {
      "UTC+0": "GMT",
      "UTC+1": "CET",
      "UTC+2": "EET",
      "UTC+3": "EEDT",
      "UTC+3.5": "IRST",
      "UTC+4": "MSD",
      "UTC+4.5": "AFT",
      "UTC+5": "PKT",
      "UTC+5.5": "IST",
      "UTC+6": "BST",
      "UTC+6.5": "MST",
      "UTC+7": "THA",
      "UTC+8": "AWST",
      "UTC+9": "AWDT",
      "UTC+9.5": "ACST",
      "UTC+10": "AEST",
      "UTC+10.5": "ACDT",
      "UTC+11": "AEDT",
      "UTC+11.5": "NFT",
      "UTC+12": "NZST",
      "UTC-1": "AZOST",
      "UTC-2": "GST",
      "UTC-3": "BRT",
      "UTC-3.5": "NST",
      "UTC-4": "CLT",
      "UTC-4.5": "VET",
      "UTC-5": "EST",
      "UTC-6": "CST",
      "UTC-7": "MST",
      "UTC-8": "PST",
      "UTC-9": "AKST",
      "UTC-9.5": "MIT",
      "UTC-10": "HST",
      "UTC-11": "SST",
      "UTC-12": "BIT"
    };
    var timezone = usertime.match(tzsregex);
    if (!timezone) {
      timezone = timezone[timezone.length - 1];
      console.log(timezone);
    } else {
      var offset = -1 * date.getTimezoneOffset() / 60;
      offset = "UTC" + (offset >= 0 ? "+" + offset : offset);
      console.log('offset', offset);
    }
  }
};